export const loggedIn = () => {
    return !!localStorage.token
};


// WEBPACK FOOTER //
// ./src/views/Login/authUtil.js